export default "__VITE_ASSET__2cdef9eb__"